import { render, staticRenderFns } from "./comfirmModal.vue?vue&type=template&id=594f9dce&scoped=true"
import script from "./comfirmModal.vue?vue&type=script&lang=js"
export * from "./comfirmModal.vue?vue&type=script&lang=js"
import style0 from "./comfirmModal.vue?vue&type=style&index=0&id=594f9dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f9dce",
  null
  
)

export default component.exports